import {AssetStarChargeSearchOption} from "../../search-option/asset/AssetStarChargeSearchOption"

/**
 * 스타 충전 검색, 계수 요청 URL 인자 구성 요소 설명
 */
export const AssetStarChargeSearchOptionDescription: Record<keyof AssetStarChargeSearchOption, string> = {
    idNeq: '기본키 불일치',
    idMin: '기본키 최소',
    idMax: '기본키 최대',
    userIdNeq: '사용자 ID 불일치',
    userIdMin: '사용자 ID 최소',
    userIdMax: '사용자 ID 최대',
    scheduledAtEq: '충전 예정 시각 일치',
    scheduledAtNeq: '충전 예정 시각 불일치',
    scheduledAtMin: '충전 예정 시각 최소',
    scheduledAtMax: '충전 예정 시각 최대',
    createdAtEq: '생성일 일치',
    createdAtNeq: '생성일 불일치',
    createdAtMin: '생성일 최소',
    createdAtMax: '생성일 최대',
}
